import React from 'react';
import { Box, Divider } from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import { useTranslation } from 'react-i18next';

interface ListDividerProps {
  unreadEventsCount: number;
}

const ListDivider: React.FC<ListDividerProps> = ({ unreadEventsCount }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ marginY: 2, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <ResponsiveTypography mediumSmall>
          {unreadEventsCount === 1
            ? t('unread_event', { count: unreadEventsCount })
            : t('unread_events', { count: unreadEventsCount })}
        </ResponsiveTypography>
      </Box>
      <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
    </Box>
  );
};

export default ListDivider;
